module.exports = __webpack_public_path__ + "img/flame_legion_charr_carving.8654d2f4.png";